import { useTranslation } from 'react-i18next';

import { ExpandableSection } from 'core/components';

import { FiltersButton } from './FiltersButton';
import { IInventoryFilterValue, InventoryFilter } from './InventoryFilter';
import { IPartSearchFilters } from './types';

interface IProps {
  filters: IPartSearchFilters;
  isActive: boolean;
  onResetFilters: () => void;
  onChangeInventoryFilter: (next: IInventoryFilterValue) => void;
  isAlternateVersionEnabled?: boolean;
}

export const PartSearchFilters = ({
  filters,
  isActive,
  onResetFilters,
  onChangeInventoryFilter,
  isAlternateVersionEnabled,
}: IProps) => {
  const { t } = useTranslation();

  if (!isAlternateVersionEnabled) {
    return null;
  }

  return (
    <FiltersButton isActive={isActive} onReset={onResetFilters}>
      <ExpandableSection title={t('headerInventory')} defaultExpanded>
        <InventoryFilter
          value={filters.inventory}
          onChange={onChangeInventoryFilter}
          isAlternateVersionEnabled={isAlternateVersionEnabled}
        />
      </ExpandableSection>
    </FiltersButton>
  );
};
